import { Box, Grid, Typography } from "@material-ui/core";
import OrganizationGroupPagesForm from "./organizationGroupPagesForm";

export default function OrganizationGroupEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Organization &gt; Edit Group
        </Typography>
      </Box>
      <Grid container xs={6}>
        <OrganizationGroupPagesForm
          description="Edit Group"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
